
import { useState } from 'react';

interface HeaderProps {
  onContactClick: () => void;
}

const Header = ({ onContactClick }: HeaderProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-blue-600" style={{ fontFamily: 'Pacifico, serif' }}>
              Autocrove
            </h1>
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('features')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              特徴
            </button>
            <button 
              onClick={() => scrollToSection('strengths')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              強み
            </button>
            <button 
              onClick={() => scrollToSection('case-studies')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              導入事例
            </button>
            <button 
              onClick={() => scrollToSection('process')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              ご利用の流れ
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              よくある質問
            </button>
            <button 
              onClick={onContactClick}
              className="bg-red-500 text-white px-6 py-2 rounded-full hover:bg-red-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              お問い合わせ
            </button>
          </nav>

          <button 
            className="md:hidden p-2 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t pt-4">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('features')}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer text-left"
              >
                特徴
              </button>
              <button 
                onClick={() => scrollToSection('strengths')}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer text-left"
              >
                強み
              </button>
              <button 
                onClick={() => scrollToSection('case-studies')}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer text-left"
              >
                導入事例
              </button>
              <button 
                onClick={() => scrollToSection('process')}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer text-left"
              >
                ご利用の流れ
              </button>
              <button 
                onClick={() => scrollToSection('faq')}
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer text-left"
              >
                よくある質問
              </button>
              <button 
                onClick={onContactClick}
                className="bg-red-500 text-white px-6 py-2 rounded-full hover:bg-red-600 transition-colors cursor-pointer text-center"
              >
                お問い合わせ
              </button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
